import { h } from "preact";

interface IProps {
  newWidgetId: number;
}

export const ObsoleteWidgetMessage = (props: IProps) => {
  const { newWidgetId } = props;

  return (
    <div>
      <span class="text-primary" style="margin-top: auto; margin-bottom: auto;">
        <div class="text-warning py-3" style="color: #a75900!important;">
          <i
            class="fa fa-info-circle line-height-1 mr-2"
            style="margin-right: 5px;"
          />
          This widget will be obsolete soon. To upgrade to the latest version
          you can either "Reset" your board or replace manually this widget by
          the{" "}
          <a
            class="text-link"
            style="
            color: #000;
            text-underline-position: under;
            text-decoration: underline;
            "
            href={`https://dashboard.sgmarkets.com/explore/widgets/${newWidgetId}`}
            target="_blank"
          >
            new version
          </a>
        </div>
      </span>
    </div>
  );
};
